import React from 'react'
import './Footer.scss';
// import logo from '../../logo.png';

// Icons //
import {IconContext} from "react-icons"
import {FaTwitter} from "react-icons/fa"
import {FaInstagram} from "react-icons/fa"

const Socials = () => {
    return (
        <IconContext.Provider value={{ style: {fontSize: '28px', color: "rgba(255, 255, 255, .8)"}}}>
        <a className="socialIcon" href="https://twitter.com/capncoverspicks" target="_blank"><FaTwitter /></a>
        <a className="socialIcon" href="https://www.instagram.com/capncoverspicks/" target="_blank"><FaInstagram /></a>
     </IconContext.Provider>
    )
  }

function Footer() {
    return (
        <div id="footer">
            <div className="row row-cols-1 row-cols-md-1 row-cols-lg-2 row-cols-xl-4 footerSpacing">
                <div className="col-md col-xl-2 mb-2">
                    <h3 className="copyright">all rights reserved</h3>
                    {/* <img className="mt-2" src={logo} alt="logo" /> */}
                </div>
                <div className="col-md col-xl-4 mb-4">
                    <h3 className="copyright">NAVIGATION</h3>
                        <li>
                            <a className="footer-link" href="#home">Home</a>
                        </li>
                        <li>
                            <a className="footer-link ms-3" href="#showcase">Showcase</a>
                        </li>
                        <li>
                            <a className="footer-link ms-3" href="#roadmap">Roadmap</a>
                        </li>
                        <li>
                            <a className="footer-link ms-3" href="#team">Team</a>
                        </li>
                </div>
                <div className="col-md col-xl-4 mb-4">
                    <h3 className="copyright">Legal</h3>
                        <li>
                            <a className="footer-link" href="">Opensea</a>
                        </li>
                        <li>
                            <a className="footer-link ms-3" href="">Discord</a>
                        </li>
                        <li>
                            <a className="footer-link ms-3" href="">Twitter</a>
                        </li>
                        <li>
                            <a className="footer-link ms-3" href="">Instagram</a>
                        </li>
                </div>
                <div className="col-md col-xl-2 col-right">
                    <Socials />
                </div>
            </div>
        </div>
    )
}

export default Footer
